// Libraries
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

// Middleware
import { listenerMiddleware } from './listenerMiddleware';

// Reducers
import appReducer from '../features/app/appSlice';
import chatReducer from '../features/chat/chatSlice';
import lobbyReducer from '../features/lobby/lobbySlice';
import sessionReducer from '../features/session/sessionSlice';
import userReducer from '../features/user/userSlice';

/**
 * @const store
 * https://redux-toolkit.js.org/api/configureStore
 */
export const store = configureStore({
    reducer: {
        app: appReducer,
        chat: chatReducer,
        lobby: lobbyReducer,
        session: sessionReducer,
        user: userReducer,
    },
    // Add the listener middleware to the store.
    // NOTE: Since this can receive actions with functions inside,
    // it should go before the serializability check middleware
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
